export const environment = {
  production: false,
  environment: 'testing',
  client: 'operator-app',
  apiUrl: 'https://api.testing.smartparking.jjames.eu',
  edgeUrl: 'https://edge.testing.jjames.eu',
  parkerUrl: 'https://parker.testing.jjames.eu',
  paymentUrl: 'https://payment.testing.jjames.eu',
  auth: {
    authority: 'https://auth.testing.smartparking.jjames.eu',
    realm: 'jjames',
    clientId: 'jjames-operator-frontend',
    clientBackend: 'jjames-backend'
  }
};
